// extracted by mini-css-extract-plugin
var _1 = "hTeGIJRlBAunU_XoOVle";
export { _1 as "subheading" }
